import * as React from 'react';
import { useCookieConsentContext, isCookieCategoryEnabled } from '@grandvisionhq/cookie-consent';
import { TealiumService } from './service.js';

const TealiumContext = /*#__PURE__*/ React.createContext({});
TealiumContext.displayName = 'TealiumContext';
const TealiumProvider = (props)=>{
    const { sdkUrl , commonEventProperties , children  } = props;
    const consentResult = useCookieConsentContext();
    const consentGranted = isCookieCategoryEnabled('analytics', consentResult);
    const ref1 = React.useRef(TealiumService.createInstance(sdkUrl));
    React.useEffect(()=>{
        var ref;
        const cleanup = (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.listen();
        return cleanup;
    }, []);
    React.useEffect(()=>{
        if (consentGranted) {
            console.log('[TealiumProvider] loading sdk');
            const service = ref1.current;
            service === null || service === void 0 ? void 0 : service.load();
            return ()=>{
                service === null || service === void 0 ? void 0 : service.teardown();
            };
        }
    }, [
        consentGranted
    ]);
    return /*#__PURE__*/ React.createElement(TealiumContext.Provider, {
        value: {
            commonEventProperties
        }
    }, children);
};
const useTealium = ()=>React.useContext(TealiumContext)
;

export { TealiumProvider, useTealium };
//# sourceMappingURL=provider.js.map
